@tailwind base;
@tailwind components;
@tailwind utilities;

@keyframes stampPulse {
  0%, 100% {
    box-shadow: 0 0 0 4px rgba(67, 56, 202, 0.25);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(67, 56, 202, 0.08);
  }
}

@keyframes recheckStampPulse {
  0%, 100% {
    box-shadow: 0 0 0 4px rgba(124, 58, 237, 0.25);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(124, 58, 237, 0.08);
  }
}